import ProjectWipGroupsConfig from './ProjectWipGroupsConfig'

export default ProjectWipGroupsConfig
